import React from 'react'
import { useIntl } from 'react-intl'
import SortByField, {
	SortByFieldProps,
} from '../formControls/SortByField'
import { MediaFileProps } from './types'

export type MediaLibrarySortFilterProps = {
	sortBy: keyof MediaFileProps
	sortDirection: 'asc' | 'desc'
	onSort?: (
		column: keyof MediaFileProps,
		direction: 'asc' | 'desc'
	) => void
}

const MediaLibrarySortFilter = ({
	sortBy = 'createdAt',
	sortDirection = 'desc',
	onSort,
}: MediaLibrarySortFilterProps) => {
	const { formatMessage } = useIntl()
	return (
		<SortByField
			menuItems={[
				{
					value: 'createdAt',
					label: formatMessage({ id: 'global.created_at' }),
				},
				{
					value: 'name',
					label: formatMessage({ id: 'global.name' }),
				},
			]}
			initialValues={{
				sortBy,
				sortDirection,
			}}
			onSort={onSort as SortByFieldProps['onSort']}
		/>
	)
}

export default MediaLibrarySortFilter
